import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useTypedParams } from 'react-router-typesafe-routes';
import ProgressButton from '@/components/common/progress-button';
import SelectContactList from '@/components/contacts/contact-list/select-contact-list';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import useAddTagMembers from '@/hooks/tags/use-add-tag-members';
import useTagMembers from '@/hooks/tags/use-tag-members';
import ROUTES from '@/routes';

export default function AddTagMembersRoute() {
  const { tagId } = useTypedParams(ROUTES.CONTACT.TAGS.BY_ID.ADD_MEMBER);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { tagMembers } = useTagMembers(tagId);
  const [selectedUserIds, setSelectedUserIds] = useState<number[]>([]);

  const { mutateAsync: addTagMembers, isPending: isAddingFriendsToGroup } = useAddTagMembers(tagId);

  const handleAddTagMembers = async () => {
    const res = await addTagMembers(selectedUserIds);
    if (res.Code === 0) {
      navigate(-1);
    }
  };

  return (
    <PageLayout
      title={t('conversation.setting.group.select-contact')}
      className='w-full'
      headerConfig={{
        navigateBack: true,
        headerLabel: t('conversation.setting.group.select-contact'),
        actions: (
          <ProgressButton
            as='button'
            className='btn btn-ghost btn-sm text-primary mode-embedded:text-primary-content'
            isLoading={isAddingFriendsToGroup}
            disabled={!selectedUserIds.length}
            onClick={handleAddTagMembers}
            label='common.add'
          />
        ),
      }}>
      <div className='flex flex-1 flex-col items-stretch'>
        <SelectContactList
          onSelectFriends={(ids) => setSelectedUserIds(ids)}
          selectedFriendIds={selectedUserIds}
          disabledUserIds={tagMembers.map((member) => member.MemberId)}
          maxSelectCount={500}
        />
      </div>
    </PageLayout>
  );
}
